var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 17,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat list"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -362,
    y: -310,
    width: 430,
    height: 932,
    rx: 45,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 234",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"lock-open-alt\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 8.93658C6.25263 8.93369 6.01032 9.00665 5.80567 9.14564C5.60102 9.28463 5.44387 9.48298 5.35536 9.71398C5.26685 9.94499 5.25124 10.1976 5.31062 10.4377C5.37 10.6779 5.50153 10.8941 5.6875 11.0572V12.1866C5.6875 12.4021 5.7731 12.6087 5.92548 12.7611C6.07785 12.9135 6.28451 12.9991 6.5 12.9991C6.71549 12.9991 6.92215 12.9135 7.07452 12.7611C7.2269 12.6087 7.3125 12.4021 7.3125 12.1866V11.0572C7.49847 10.8941 7.63 10.6779 7.68938 10.4377C7.74876 10.1976 7.73315 9.94499 7.64464 9.71398C7.55613 9.48298 7.39898 9.28463 7.19433 9.14564C6.98968 9.00665 6.74737 8.93369 6.5 8.93658ZM10.5625 5.68658H4.0625V4.06158C4.06132 3.57911 4.20334 3.10714 4.47059 2.70544C4.73783 2.30374 5.11828 1.99039 5.56374 1.80507C6.0092 1.61975 6.49965 1.5708 6.97295 1.66442C7.44625 1.75803 7.88113 1.99001 8.2225 2.33096C8.52796 2.64301 8.74644 3.02956 8.85625 3.45221C8.88292 3.5557 8.92972 3.65293 8.99397 3.73835C9.05823 3.82376 9.13867 3.89568 9.23072 3.95C9.32276 4.00432 9.42461 4.03998 9.53044 4.05495C9.63626 4.06991 9.744 4.06388 9.8475 4.03721C9.951 4.01053 10.0482 3.96373 10.1336 3.89948C10.2191 3.83523 10.291 3.75478 10.3453 3.66274C10.3996 3.57069 10.4353 3.46885 10.4502 3.36302C10.4652 3.25719 10.4592 3.14945 10.4325 3.04596C10.2474 2.34298 9.88027 1.70122 9.36812 1.18533C8.79952 0.618503 8.07571 0.232866 7.28809 0.0771154C6.50047 -0.0786351 5.68436 0.00248487 4.94281 0.310232C4.20126 0.617979 3.56753 1.13855 3.12163 1.80622C2.67573 2.47389 2.43767 3.25871 2.4375 4.06158V5.68658C1.79103 5.68658 1.17105 5.94339 0.713927 6.40051C0.256807 6.85763 0 7.47761 0 8.12408V13.8116C0 14.458 0.256807 15.078 0.713927 15.5352C1.17105 15.9923 1.79103 16.2491 2.4375 16.2491H10.5625C11.209 16.2491 11.829 15.9923 12.2861 15.5352C12.7432 15.078 13 14.458 13 13.8116V8.12408C13 7.47761 12.7432 6.85763 12.2861 6.40051C11.829 5.94339 11.209 5.68658 10.5625 5.68658ZM11.375 13.8116C11.375 14.0271 11.2894 14.2337 11.137 14.3861C10.9847 14.5385 10.778 14.6241 10.5625 14.6241H2.4375C2.22201 14.6241 2.01535 14.5385 1.86298 14.3861C1.7106 14.2337 1.625 14.0271 1.625 13.8116V8.12408C1.625 7.90859 1.7106 7.70193 1.86298 7.54956C2.01535 7.39718 2.22201 7.31158 2.4375 7.31158H10.5625C10.778 7.31158 10.9847 7.39718 11.137 7.54956C11.2894 7.70193 11.375 7.90859 11.375 8.12408V13.8116Z",
    fill: "#347AE2"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -362,
    y: -310,
    width: 430,
    height: 932,
    rx: 45,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 1071,
    fill: "white",
    transform: "translate(-362 -126)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lockOpen.2a036d66668c4db8d5f7a07a1366100b.svg";
export { ForwardRef as ReactComponent };